<div id="enrollment-agreement">
  <div class="page1 border border-dark p-3">

    <h3 class="text-end fst-italic fw-bold mb-3">STUDENT ENROLLMENT AGREEMENT</h3>

    <!-- Student Information -->
    <div class="d-flex border-bottom pb-1 mb-1">
      <span class="fw-bold me-2" style="white-space:nowrap;">Student</span>
      <div class="d-flex flex-grow-1 gap-3">
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">First Name</small>
          <span>{{ primaryContact?.field_first_name || entityData?.['field_student']?.['title']?.split(' ')[0] || '' }}</span>
        </div>
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">Last Name</small>
          <span>{{ primaryContact?.field_last_name || entityData?.['field_student']?.['title']?.split(' ').slice(1).join(' ') || '' }}</span>
        </div>
        <div class="flex-grow-1">
          <small class="text-muted d-block" style="font-size:0.7rem;">Street Address</small>
          <span>{{ primaryContact?.field_address?.address_line1 || '' }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex gap-3 border-bottom pb-1 mb-3">
      <div>
        <span class="fw-bold me-1">City</span>
        <span>{{ primaryContact?.field_address?.locality || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">State</span>
        <span>{{ primaryContact?.field_address?.administrative_area || '' }}</span>
      </div>
      <div>
        <span class="fw-bold me-1">ZIP</span>
        <span>{{ primaryContact?.field_address?.postal_code || '' }}</span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Phone</span>
        <span>{{ primaryContact?.field_cell_phone || '' }}</span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Email</span>
        <span>{{ primaryContact?.field_email || '' }}</span>
      </div>
    </div>

    <!-- Enrollment type + lesson table -->
    <div class="row mb-2">
      <div class="col-3">
        <p class="fw-bold mb-2">TYPE OF ENROLLMENT<br>CHECK</p>
        <div class="d-flex align-items-center mb-1">
          <span class="border border-dark d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.original ? '#000' : '#fff'"></span>
          <span>ORIGINAL</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="border border-dark d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.extension ? '#000' : '#fff'"></span>
          <span>EXTENSION</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="border border-dark d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.renewal ? '#000' : '#fff'"></span>
          <span>RENEWAL</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="border border-dark d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.service ? '#000' : '#fff'"></span>
          <span>SERVICE</span>
        </div>
      </div>
      <div class="col-9">
        <p class="small mb-2">The Student agrees to purchase and the owner of the Arthur Murray&reg; Franchised Dance Studio agrees to provide the following course of dance instruction and/or services on the following terms and conditions including the terms and conditions on the reverse side of this agreement.</p>

        <table class="table table-bordered text-center small mb-1">
          <tr>
            <td class="fw-bold">PRIVATE LESSONS</td>
            <td class="fw-bold">CLASS LESSONS</td>
            <td class="fw-bold">PRACTICE LESSONS</td>
            <td class="fw-bold">VIDEO STUDIES</td>
            <td class="fw-bold">TUITION</td>
            <td class="fw-bold">DISCOUNT</td>
            <td class="fw-bold">BALANCE DUE</td>
          </tr>
          <tr>
            <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td>${{ getOriginalPackageCost() | number:'1.2-2' }}</td>
            <td>${{ getDiscount() | number:'1.2-2' }}</td>
            <td>${{ calculateTotalTuition() | number:'1.2-2' }}</td>
          </tr>
        </table>

        <p class="fw-bold text-center small mb-1">LESSONS ARE 45 MINUTES WHICH INCLUDES TRANSITION TIME BETWEEN LESSONS</p>

        <table class="table table-bordered small mb-0">
          <tr>
            <td class="fw-bold text-center">TYPE OF MISCELLANEOUS SERVICE(S)</td>
            <td class="fw-bold text-center" style="width:25%">TUITION OR COST</td>
          </tr>
          <tr>
            <td>{{ getNotes() }}</td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Acknowledgment -->
    <p class="small mb-3">The Student acknowledges the above of <span class="border-bottom px-3 fw-bold">${{ calculateTotalTuition() | number:'1.2-2' }}</span> for the instruction and/or service(s) described above and agrees to pay <span class="border-bottom px-3 fw-bold">${{ getDownPaymentAmount() | number:'1.2-2' }}</span> today and the remaining cash balance as follows:</p>

    <!-- Lending disclosures (installment agreements) -->
    <div *ngIf="isInstallmentAgreement" class="border-top border-bottom border-dark py-2 mb-3">
      <p class="text-center fst-italic small mb-2">(If this is an Installment Agreement, please complete the section below, if applicable)<br>
        <span class="fw-bold">Lending Disclosure for Budget Courses or Studio Payment Programs</span></p>

      <div class="row">
        <div class="col-6">
          <table class="table table-sm table-borderless small mb-2">
            <tr><td>1. Cash price of this course.....................................</td><td class="text-end">${{ calculateTotalTuition() | number:'1.2-2' }}</td></tr>
            <tr><td>2. Outstanding Balance of Previous Agreement...</td><td class="text-end">${{ (entityData?.field_outstanding_balance_pc || 0) | number:'1.2-2' }}</td></tr>
            <tr><td>3. Unearned Finance Charge...............................</td><td class="text-end">${{ (entityData?.field_unearned_finance_charge || 0) | number:'1.2-2' }}</td></tr>
            <tr><td>4. Previous Balance to be Refinanced (2-3 if any)...</td><td class="text-end">${{ ((entityData?.field_outstanding_balance_pc || 0) - (entityData?.field_unearned_finance_charge || 0)) | number:'1.2-2' }}</td></tr>
            <tr><td>5. Consolidated Cash Price (1+4)..........................</td><td class="text-end">${{ (calculateTotalTuition() + ((entityData?.field_outstanding_balance_pc || 0) - (entityData?.field_unearned_finance_charge || 0))) | number:'1.2-2' }}</td></tr>
            <tr><td>6. Cash Down Payment.........................................</td><td class="text-end">${{ getDownPaymentAmount() | number:'1.2-2' }}</td></tr>
          </table>

          <div class="border border-dark p-2 mb-1 small">
            <strong>AMOUNT FINANCED</strong>
            <div class="d-flex justify-content-between align-items-end">
              <span>The amount of credit provided to you or on your behalf.........</span>
              <span class="text-nowrap ms-2">${{ calculateTotalTuition() | number:'1.2-2' }}</span>
            </div>
          </div>
          <div class="border border-dark p-2 mb-1 small">
            <strong>FINANCE CHARGE</strong>
            <div class="d-flex justify-content-between align-items-end">
              <span>The dollar amount the credit will cost you.............</span>
              <span class="text-nowrap ms-2">${{ (entityData?.field_finance_charge || 0) | number:'1.2-2' }}</span>
            </div>
          </div>
          <div class="border border-dark p-2 mb-1 small">
            <strong>TOTAL OF PAYMENTS</strong>
            <div class="d-flex justify-content-between align-items-end">
              <span>The amount you will have paid after you have made all payments as scheduled.............</span>
              <span class="text-nowrap ms-2">${{ calculateTotalTuition() | number:'1.2-2' }}</span>
            </div>
          </div>
          <div class="border border-dark p-2 mb-1 small">
            <strong>TOTAL SALE PRICE</strong>
            <div class="d-flex justify-content-between align-items-end">
              <span>The total cost of your purchase on credit including your down payment of ${{ getDownPaymentAmount() | number:'1.2-2' }}.............</span>
              <span class="text-nowrap ms-2">${{ calculateTotalTuition() | number:'1.2-2' }}</span>
            </div>
          </div>
          <div class="border border-dark p-2 mb-1 small">
            <strong>ANNUAL PERCENTAGE RATE</strong>
            <div class="d-flex justify-content-between align-items-end">
              <span>The cost of your credit as a yearly rate.............</span>
              <span class="text-nowrap ms-2">{{ entityData?.field_finance_apr || 0 }}%</span>
            </div>
          </div>
        </div>

        <div class="col-6">
          <p class="small mb-1"><strong>Credit Information</strong></p>
          <p class="small mb-0">Employer: ___________________________________</p>
          <p class="small mb-0">Address: ____________________________________</p>
          <p class="small mb-2">How Long: _________ Income: _________ wk.&#9633; mo.&#9633; yr.&#9633;</p>
          <p class="small mb-2">You have the right at this time to receive an itemization of the amount financed. Itemization shown in the left column of this document.</p>

          <p class="small fw-bold mb-1">Your payment schedule will be:</p>
          <ng-container *ngIf="areAllPaymentAmountsSame(); else detailedPayments">
            <table class="table table-bordered text-center small mb-1">
              <tr>
                <th>Number of Payments</th>
                <th>Amount of Payments</th>
                <th>Payments Due</th>
              </tr>
              <tr>
                <td>{{ allPaymentRows.length || '' }}</td>
                <td>{{ allPaymentRows.length ? ('$' + (allPaymentRows[0].amount | number:'1.2-2')) : '' }}</td>
                <td>{{ firstPaymentDate ? (firstPaymentDate | date) : 'Not specified' }}</td>
              </tr>
            </table>
          </ng-container>
          <ng-template #detailedPayments>
            <table class="table table-bordered text-center small mb-1">
              <tr>
                <th>Payment #</th>
                <th>Amount</th>
                <th>Due Date</th>
              </tr>
              <tr *ngFor="let payment of allPaymentRows; let i = index">
                <td>{{ i + 1 }}</td>
                <td>${{ payment.amount | number:'1.2-2' }}</td>
                <td>{{ payment.date ? (payment.date | date) : '' }}</td>
              </tr>
            </table>
          </ng-template>
          <p class="small mb-2">Payments due as scheduled above, until paid in full.</p>

          <p class="small mb-2"><strong>Notice to Buyer:</strong> Do not sign this agreement before you read it or if it contains blank spaces. You are entitled to a copy of the agreement you sign. Keep this agreement to protect your legal rights.</p>

          <div class="payoff-section small">
            <p class="mb-2 fw-semibold">If you pay off early, you:</p>
            <div class="payoff-row">
              <div class="payoff-options">
                <div class="choice-box" role="checkbox" [attr.aria-checked]="earlyPaymentPenalty" [class.is-checked]="earlyPaymentPenalty">
                  <span class="choice-square" aria-hidden="true"></span>
                  <span class="choice-label">May</span>
                </div>
                <div class="choice-box" role="checkbox" [attr.aria-checked]="!earlyPaymentPenalty" [class.is-checked]="!earlyPaymentPenalty">
                  <span class="choice-square" aria-hidden="true"></span>
                  <span class="choice-label">May not</span>
                </div>
              </div>
              <div class="payoff-note">have to pay a penalty</div>
            </div>
            <div class="payoff-row">
              <div class="payoff-options">
                <div class="choice-box" role="checkbox" [attr.aria-checked]="earlyPaymentRefund" [class.is-checked]="earlyPaymentRefund">
                  <span class="choice-square" aria-hidden="true"></span>
                  <span class="choice-label">May</span>
                </div>
                <div class="choice-box" role="checkbox" [attr.aria-checked]="!earlyPaymentRefund" [class.is-checked]="!earlyPaymentRefund">
                  <span class="choice-square" aria-hidden="true"></span>
                  <span class="choice-label">Will not</span>
                </div>
              </div>
              <div class="payoff-note">be entitled to a refund or part of the finance charge under rule of 78, pro-rata or actuarial method, whichever is applicable in your state.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="fw-bold text-center small mb-3">STUDENT ACKNOWLEDGES RECEIPT OF AN EXACT COPY OF THIS RETAIL INSTALLMENT AGREEMENT.</p>

    <p class="small fst-italic mb-3">It is agreed that the Studio's obligation for furnishing instructions under this agreement shall expire on
      <span class="fw-bold border-bottom px-2">{{ expirationDate ? (expirationDate | date) : '____________' }}</span>
      or two years from the date of this agreement, whichever occurs first.</p>

    <!-- Studio box + signatures -->
    <div class="row">
      <div class="col-6">
        <div class="border border-dark p-2 text-center small mb-2">
          <p class="fw-bold mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.organization || this.studioInformationConfig?.field_studio_display_name?.[0]?.value || '' }}</p>
          <p class="mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }}
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }}
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
            {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}</p>
          <p class="mb-0">Ph: {{ this.studioInformationConfig?.field_studio_phone_number?.[0]?.value }}</p>
          <p class="mb-0">Email: {{ this.studioInformationConfig?.field_studio_email?.[0]?.value }}</p>
        </div>
        <ng-container *ngIf="displaySigned">
          <p class="small mb-0">By:</p>
          <div class="border-bottom" style="height:30px;">
            <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
                 class="img-fluid" style="max-height:28px;"
                 [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
          </div>
          <small class="text-muted">Studio Representative</small>
        </ng-container>
      </div>
      <div class="col-6" *ngIf="displaySigned">
        <p class="small mb-2">Signed this <span class="fw-bold">{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span></p>
        <div class="border-bottom" style="height:30px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
               class="img-fluid" style="max-height:28px;"
               [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
        </div>
        <small class="text-muted d-block mb-2">Student's Signature</small>
        <div class="border-bottom" style="height:30px;">
          <img *ngIf="displaySignatures && _enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']"
               class="img-fluid" style="max-height:28px;"
               [src]="_enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']" />
        </div>
        <small class="text-muted d-block mb-2">Co-Student or Guardian</small>
        <p class="small mb-0">Verified By:</p>
        <div class="border-bottom" style="height:30px;"></div>
      </div>
    </div>

  </div>

  <!-- The Premium Dance Program back page is generated by
       getEnrollmentAgreementBackpageContent() (enrollment-agreement-backpage.content.ts)
       and rendered/printed after this agreement, same as the other templates. -->
</div>
